import { AfterViewInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { FormServices } from 'src/app/services/form.services';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ColDef, ColumnMovedEvent, ColumnResizedEvent, ColumnState, GridApi, GridReadyEvent, IRowNode, RowClickedEvent, RowDoubleClickedEvent, RowNode } from '@ag-grid-community/core';
import { localePt } from "../../../assets/locale.pt.js";
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DialogService } from 'src/app/services/dialog.service';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { FormItemCanceling, FormItemConfiguration, FormItemEditData, FormItemSaving } from 'src/app/system-utils/form-item-component/form-item-component.component';
import { ThemeService } from 'src/app/services/theme.service';
import { LanguageServices } from 'src/app/services/LanguageServices';


@Component({
    selector: 'edit-data-grid',
    templateUrl: './edit-data-grid.component.html',
    styleUrl: './edit-data-grid.component.scss',
    standalone: false
})

export class EditDataGridComponent implements OnInit,OnDestroy {
  
  customEditComponent:boolean  = false;
  private gridApi!: GridApi;
  editFace:boolean = false;
  selectedNodes: IRowNode<any>[];
  @ViewChild("outlet", {read: ViewContainerRef}) outletRef: ViewContainerRef;
  @ViewChild("content", {read: TemplateRef}) contentRef: TemplateRef<any>;

  displayedColumns:ColDef[] = [];


  @Input() resourceId= null;
  @Input() formItemConfiguration: FormItemConfiguration[] = [];
  @Input() buttonList:ButtonList[] = [];
  @Input() rows:any[];
  @Output() rowsChange:EventEmitter<any[]> = new EventEmitter();
  form:FormGroup;
  editData:FormItemEditData = null;
  sub:Subscription;
  name: string;
  idUser: number;
  tabName: string;
  newValue: boolean = false;
  filters: string[];
  constructor(
            public formBuilder:FormBuilder,
            public formServices:FormServices,
            private snackBar:SnackbarService,
            private dialogServices:DialogService,
            private userServices:UserConfigServices,
            private uas:UserAuthenticationServices,
            public ThemeService:ThemeService,
            public ls:LanguageServices
  ){}

  getRowId(params) {
    return params.data.rowId;
  }
  
  eventGridSelect(event: RowClickedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
  }

  onGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;    
    this.sub = this.userServices.loadUserResource(this.uas.user.iduser,this.resourceId).subscribe({
      next:(data)=>{
          let arr:Object[] = data['Mktpuserpref'];
          if ( arr.length > 0){
            let obj = arr[0];
            if ( obj['PREFERENCE'] != null ){
              
              let config:ColumnState[] = JSON.parse(obj['PREFERENCE']);
              this.gridApi.applyColumnState({ state: config,applyOrder: true });
            }
          }
      }
    })
    //this.gridApi.applyTransaction({add:this.rows});
  }

  ngOnDestroy(): void {
      if ( this.sub != null ){ this.sub.unsubscribe(); }
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({});
    this.idUser = this.uas.user.iduser;
    
    
    // this.form = this.formBuilder.group({
    //     title: new FormControl<string>(null,Validators.required),
    //     query: new FormControl<string>(null),
    //     refresh: new FormControl<number>(null),
    //     options: this.formBuilder.group({
    //         showPaginator: new FormControl<boolean>(false),
    //         canExport: new FormControl<boolean>(false),
    //         canClipboard: new FormControl<boolean>(false),
    //         colorLinesFormula: new FormControl<string>(null),
    //         fields: this.formBuilder.array([])
    //     })
    // });

    //this.formServices.refreshFormObject(this.form,this.item);
  }
  initialize() {
    if ( this.rows.length > 0 ){
      this.rows = this.rows.map((d,index)=>({rowId:index,...d}));
    }
    
    if ( this.formItemConfiguration != null ){
      let rowId:ColDef ={
          colId:'rowId',
          field:'rowId',
          hide: true
      }
      this.displayedColumns.push(rowId);

      this.formItemConfiguration.forEach(item=>{
            if ( item.colDef != null ){
              item.colDef.headerName = item.title;
              item.colDef.headerTooltip = item.tooltip;
              item.colDef.colId = item.name;
              item.colDef.field = item.name;
              this.displayedColumns.push(item.colDef);
            }
        });
    }
  }
  
  okFunction(){
    
    if ( this.form.valid ){
      if ( this.newValue ){
        //TODO 
      }
    }else{
      this.snackBar.showError(JSON.stringify(this.form.errors));
      this.form.updateValueAndValidity();
    }
  }


  add(){
    this.editFace = !this.editFace;
    this.form.reset();
    this.editData = {
        index: -1,
        data: null
    };
  }

  remove(){

    let cnt = this.selectedNodes.length;

    if (cnt == 0) {
      this.snackBar.showError("Nenhuma linha selecionada.");
      return;
    }

    try {
      this.dialogServices.title = "Exclusão de Dados";
      this.dialogServices.openNewDialog(
        "Excluir os itens selecionados?",
        () => {
          this.selectedNodes.forEach(async (rowNode: RowNode) => {
            let x = rowNode.data;
            let i = this.rows.findIndex(d=>d.rowId==x.rowId);
            this.rows.splice(i,1);
            this.gridApi.applyTransaction({ remove: [rowNode.data] });
            this.rowsChange.emit(this.rows);
        });
      }
      );
    } catch (Exception) {
      throw Exception;
    }
  }

  onSavingArray(evento:FormItemSaving){
      if ( evento.new ){
        this.rows.push(evento.form.getRawValue());
        this.gridApi.applyTransaction({add:[evento.form.getRawValue()]});
      }else{
        this.rows[evento.index] = evento.form.getRawValue();
        this.gridApi.applyTransaction({update:[evento.form.getRawValue()]})
      }
      
      this.editFace = false;
      this.rowsChange.emit(this.rows);
  }

  onCanceling(evento:FormItemCanceling){
      this.editFace = false;
  }

  ngAfterViewInit() {
    this.initialize();
    const compRef = this.outletRef.createEmbeddedView(this.contentRef);
    compRef.detectChanges();
  }

  selectRow(evento:RowDoubleClickedEvent){
      this.editFace = true;
      this.editData = {
        data:evento.data,
        index:evento.rowIndex
      }
  }

  public onReoder(evento:ColumnMovedEvent): void {
    if ( evento.finished ){
      this.userServices.saveUserResource(this.resourceId,this.uas.user.iduser,evento.api.getColumnState());
    }
  }

  public onResize(event: ColumnResizedEvent): void {
    try {
      if (event.finished) {
          let config = event.api.getColumnState();
          this.userServices.saveUserResource(this.resourceId,this.uas.user.iduser,config);
        } 
    } catch (Exception) {
      throw Exception;
    }
  }



}
